export enum ActivityStatusType {
    NotStarted= 1,
    EnRoute= 2,
    InProgress= 3,
    Complete= 4,
    NeedsAction= 5
}
